import styled from 'styled-components';

export const EnterpriseSection = styled.section<{ $isVisible?: boolean }>`
  padding: 120px 0;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #050505 0%, #0a0a0a 100%);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  }

  @media (max-width: 768px) {
    padding: 80px 0;
  }
`;

export const EnterpriseGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 60px;
  }
`;

export const EnterpriseContent = styled.div`
  position: relative;
`;

export const EnterpriseList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const EnterpriseItem = styled.li<{ $isVisible?: boolean; $delay?: number }>`
  padding: 16px 0;
  padding-left: 32px;
  position: relative;
  font-size: 1.125rem;
  color: #d4d4d8;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transform: translateX(${props => props.$isVisible ? '0' : '-20px'});
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${props => props.$delay ? `${props.$delay}ms` : '0ms'};

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff4444, #ff6b6b);
    box-shadow: 0 0 20px rgba(255, 68, 68, 0.4);
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }
`;

export const EnterpriseStats = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const EnterpriseStat = styled.div<{ $isVisible?: boolean; $delay?: number }>`
  padding: 32px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  text-align: center;
  opacity: ${props => props.$isVisible ? 1 : 0};
  transform: translateY(${props => props.$isVisible ? '0' : '20px'});
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${props => props.$delay ? `${props.$delay}ms` : '0ms'};

  &:hover {
    background: rgba(255, 255, 255, 0.04);
    border-color: rgba(255, 68, 68, 0.2);
  }
`;

export const EnterpriseStatNumber = styled.div`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #ff4444, #ff6b6b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
`;

export const EnterpriseStatLabel = styled.div`
  font-size: 0.9rem;
  color: #a1a1aa;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;
